import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFilter',
})
export class NumberFilterPipe implements PipeTransform {
  transform(value: string): string {
    return value?.replace(/\D/g, '') || '';
  }
}
